import z from 'zod';

/** Schema to validate chat attributes. */
export const chatAttributesSchema = z.object({
  chat_id: z.number(),
});

/** Chat attributes. */
export type ChatAttributes = z.infer<typeof chatAttributesSchema>;
